import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
}
export function FAQItem({
  question,
  answer
}: FAQItemProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className="border-b border-terracotta/20 py-4" data-id="element-1">
      <button onClick={() => setIsOpen(!isOpen)} className="flex w-full items-center justify-between text-left focus:outline-none group" data-id="element-2">
        <span className="font-serif text-xl font-semibold text-earth-dark group-hover:text-terracotta transition-colors" data-id="element-3">
          {question}
        </span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} className="text-terracotta ml-4 flex-shrink-0" data-id="element-4">
          <ChevronDown size={24} data-id="element-5" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-6">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} className="overflow-hidden" data-id="element-7">
            <p className="pt-4 text-earth-medium leading-relaxed" data-id="element-8">{answer}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}